import { config } from "@/config";
export class EquivalenteService {
    static getHeaders() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        };
    }
    static async getAll(search = "", page = 1, letter = "", filterType = "ambos", departamentoId, categoriaId) {
        const url = new URL(`${config.API_URL}/api/Equivalentes`);
        if (search)
            url.searchParams.append("search", search);
        if (letter)
            url.searchParams.append("letter", letter);
        url.searchParams.append("filterType", filterType);
        url.searchParams.append("page", page.toString());
        if (departamentoId)
            url.searchParams.append("departamentoId", departamentoId.toString());
        if (categoriaId)
            url.searchParams.append("categoriaId", categoriaId.toString());
        const response = await fetch(url.toString(), {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener equivalentes");
        return response.json();
    }
    static async getById(id) {
        const response = await fetch(`${config.API_URL}/api/Equivalentes/${id}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener el equivalente");
        return response.json();
    }
    static async create(formData) {
        const response = await fetch(`${config.API_URL}/api/Equivalentes`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: formData,
        });
        if (!response.ok)
            throw new Error("Error al crear equivalente");
        return response.json();
    }
    static async bulkCreate(payload) {
        const response = await fetch(`${config.API_URL}/api/Equivalentes/bulk`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify(payload),
        });
        if (!response.ok)
            throw new Error("Error al crear equivalentes por lote");
        return response.json();
    }
    static async update(id, formData) {
        const response = await fetch(`${config.API_URL}/api/Equivalentes/${id}`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: formData,
        });
        if (!response.ok) {
            let errorMsg = `Error ${response.status} al actualizar equivalente`;
            try {
                const errorBody = await response.json();
                errorMsg =
                    errorBody?.errores?.join(", ") ||
                        errorBody?.title ||
                        errorBody?.message ||
                        JSON.stringify(errorBody);
            }
            catch {
                /* ignore parse error */
            }
            throw new Error(errorMsg);
        }
        return response.json();
    }
    static async updateReplica(id, payload) {
        const response = await fetch(`${config.API_URL}/api/Equivalentes/Replicas/${id}`, {
            method: "PUT",
            headers: this.getHeaders(),
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            let errorMsg = `Error ${response.status} al actualizar réplica`;
            try {
                const errorBody = await response.json();
                errorMsg =
                    errorBody?.errores?.join(", ") ||
                        errorBody?.title ||
                        errorBody?.message ||
                        JSON.stringify(errorBody);
            }
            catch {
                /* ignore parse error */
            }
            throw new Error(errorMsg);
        }
        return response.json();
    }
    static async delete(id) {
        const response = await fetch(`${config.API_URL}/api/Equivalentes/${id}`, {
            method: "DELETE",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al eliminar equivalente");
        return response.json();
    }
    static async getUltimoCodigo() {
        const response = await fetch(`${config.API_URL}/api/Equivalentes/ultimo-codigo`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener el último código");
        return response.json();
    }
    static async exportReport(payload) {
        const response = await fetch(`${config.API_URL}/api/Equivalentes/export`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify(payload),
        });
        if (!response.ok)
            throw new Error("Error al exportar el reporte");
        const format = payload.format || "excel";
        const extension = format === "pdf" ? "pdf" : "xlsx";
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Equivalentes_${new Date()
            .toISOString()
            .slice(0, 19)
            .replace(/[-T:]/g, "")}.${extension}`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
}
